import React, { useEffect, useState } from 'react';
import api from '../services/api';
import searchIcon from '../assets/images/search_icon.svg';
import arrowIcon from '../assets/images/Arrow.svg';
import "../styles/dataTable.css";
import { toast } from 'react-toastify';

const ActiveServiceProviders = () => {
  const [rows, setRows] = useState([]);
  const [plansMap, setPlansMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    fetchPlans();
    fetchServiceProviders();
  }, []);

  // Format date to DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  // Fetch all plans and create map { plan_id: plan_name }
  const fetchPlans = async () => {
    try {
      const res = await api.get('/service-plan/get-all');
      const data = (res.data && res.data.data) || [];

      const map = {};
      data.forEach(plan => {
        map[plan.id || plan.plan_id] = plan.plan_name;
      });

      setPlansMap(map);
    } catch (error) {
      console.error('Error fetching plans:', error);
      toast.error('Error fetching plans');
    }
  };

  // Fetch service provider plan data
  const fetchServiceProviders = async () => {
    setLoading(true);
    try {
      const res = await api.get('/service-plan/get-all-serviceprovider');
      const data = (res.data && res.data.data) || [];

      const formatted = data.map(item => ({
        name: item.name || '—',
        plan_id: item.plan_id || '',
        transaction_id: item.transaction_id || '—',
        amount_paid: item.amount_paid || '—',
        payment_date: formatDate(item.payment_date),
        expiry_date: formatDate(item.expiry_date),
        status: item.status || '—'
      }));

      setRows(formatted);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Error fetching service providers');
    } finally {
      setLoading(false);
    }
  };

let filtered = rows.filter(r => {
  if (!search) return true;
  const planName = plansMap[r.plan_id] || '';
  return (
    r.name.toLowerCase().includes(search.toLowerCase()) ||
    planName.toLowerCase().includes(search.toLowerCase())
  );
});

// ✅ Sort only by Name
filtered.sort((a, b) => {
  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();

  return sortOrder === "asc"
    ? nameA.localeCompare(nameB)
    : nameB.localeCompare(nameA);
});

  const totalPages = Math.max(1, Math.ceil(filtered.length / entriesPerPage));
  const pageData = filtered.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  const handleNameSort = () => {
  setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
};

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <div style={{ padding: "20px" }}>
        <div className="table-header">
          <h2 style={{ fontWeight: 700 }}>Tour Operator & Plans</h2>

          <div className="search-container">
            <input
              value={search}
              onChange={e => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="search"
            />
            <img src={searchIcon} alt="search-icon" className="search-icon" />
          </div>

          <div className="entries-container">
            <label htmlFor="noOfEntries">Show: </label>
            <select
              value={entriesPerPage}
              id="noOfEntries"
              onChange={e => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries per page</option>
              <option value={50}>50 Entries per page</option>
              <option value={100}>100 Entries per page</option>
            </select>
          </div>
        </div>

        <table width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              <th onClick={handleNameSort} style={{ cursor: "pointer" }}>
                Name {sortOrder === "asc" ? "▲" : "▼"}
              </th>
              <th>Plan Name</th>
              <th>Transaction ID</th>
              <th>Amount Paid</th>
              <th>Payment Date</th>
              <th>Expiry Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center' }}>
                  Loading...
                </td>
              </tr>
            ) : pageData.length ? (
              pageData.map((r, index) => (
                <tr key={index}>
                  <td>{r.name}</td>
                  <td>{plansMap[r.plan_id] || '—'}</td>
                  <td>{r.transaction_id}</td>
                  <td>{r.amount_paid}</td>
                  <td>{r.payment_date}</td>
                  <td>{r.expiry_date}</td>
                  <td >
                  <div className='status' style={{ background: r.status === 'active' ? 'green' : 'red', borderRadius: '50px', padding: '5px 10px', textTransform: 'capitalize',textAlign: 'center', color: 'white' }}>
                    {r.status}
                  </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: 'center' }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div style={{ paddingBottom: '30px', background: '#fff' }}>
          <div
            style={{
              padding: "30px",
              textAlign: "center",
              borderTop: '2px solid #F2F2F2',
              borderBottom: '2px solid #F2F2F2'
            }}
          >
            <button
              onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              style={{
                margin: "0 5px",
                border: "none",
                background: "#fff",
                cursor: currentPage === 1 ? "not-allowed" : "pointer"
              }}
            >
              <img src={arrowIcon} alt="prev" style={{ opacity: currentPage === 1 ? 0.5 : 1 }} />
            </button>

            {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
              <button
                key={p}
                onClick={() => setCurrentPage(p)}
                style={{
                  margin: "0 5px",
                  padding: "5px 10px",
                  background: currentPage === p ? "#D9D9D9" : "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                {p}
              </button>
            ))}

            <button
              onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{
                margin: "0 5px",
                border: "none",
                background: "#fff",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer"
              }}
            >
              <img
                src={arrowIcon}
                alt="next"
                style={{
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  transform: 'rotateY(180deg)'
                }}
              />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ActiveServiceProviders;